var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H5.16667V7.16667H4V6ZM4 8.33333H5.16667V9.5H4V8.33333ZM6.33333 6H7.5V7.16667H6.33333V6ZM6.33333 8.33333H7.5V9.5H6.33333V8.33333ZM8.66667 6H9.83333V7.16667H8.66667V6ZM8.66667 8.33333H9.83333V9.5H8.66667V8.33333Z",
    fill: "#4750A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 12.8346H11.0833C11.7267 12.8346 12.25 12.3114 12.25 11.668V3.5013C12.25 2.85789 11.7267 2.33464 11.0833 2.33464H9.91667V1.16797H8.75V2.33464H5.25V1.16797H4.08333V2.33464H2.91667C2.27325 2.33464 1.75 2.85789 1.75 3.5013V11.668C1.75 12.3114 2.27325 12.8346 2.91667 12.8346ZM11.0833 4.66797L11.0839 11.668H2.91667V4.66797H11.0833Z",
    fill: "#4750A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.5baa12aa37a5420017fb21a158866ead.svg";
export { ForwardRef as ReactComponent };